import React from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheUIHeadline, RocheUIHeadlineLevel } from '@repo/roche-ui';

type RocheHeadlineProps = BlokToComponentProps<{
  headline: string;
  level: RocheUIHeadlineLevel;
}>;

export const RocheHeadline = ({ blok: { headline, level }, slot }: RocheHeadlineProps): JSX.Element => {
  return <RocheUIHeadline headline={headline || undefined} level={level as RocheUIHeadlineLevel} slot={slot} />;
};
